module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('p', {
    staticClass: "card__status",
    class: ("card__status_" + (_vm.status.color))
  }, [_vm._v(_vm._s(_vm.status.text))]), _c('div', {
    staticClass: "card__body"
  }, [_c('div', {
    staticClass: "card__main"
  }, [_c('Picture', {
    staticClass: "card__image",
    attrs: {
      "src": _vm.item.event_image,
      "alt": _vm.item.event_name
    }
  }), _c('h3', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.item.event_name))]), _c('div', {
    staticClass: "card__text"
  }, [_c('Infoblock', {
    attrs: {
      "name": "Заявка №"
    }
  }, [_vm._v(_vm._s(_vm.item.order_id))]), _c('Infoblock', {
    attrs: {
      "name": "Номер договора"
    }
  }, [_vm._v(_vm._s(_vm.item.serial))])], 1), _c('Infoblock', {
    staticClass: "card__date",
    attrs: {
      "bold": "bold",
      "name": "Начало обучения"
    }
  }, [_vm._v(_vm._s(_vm.item.start_date_plan))]), _c('div', {
    staticClass: "card__actions"
  }, [(_vm.status.text === 'Ожидает подписания') ? _c('Button', {
    staticClass: "card__action card__action_assign",
    on: {
      "click": _vm.assign
    }
  }, [_vm._v("Подписать")]) : _vm._e(), _c('Button', {
    staticClass: "card__action card__action_download",
    attrs: {
      "bordered": "bordered"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Скачать")]), _c('Button', {
    staticClass: "card__action card__action_more",
    attrs: {
      "bordered": "bordered"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("Подробнее")])], 1)], 1), _c('Accordion', {
    attrs: {
      "opened": _vm.opened
    }
  }, [_c('div', {
    staticClass: "card__contract"
  }, [_c('div', {
    staticClass: "card__cost"
  }, [_c('Miniheader', {
    attrs: {
      "inline": "inline"
    }
  }, [_vm._v("Стоимость услуг: ")]), _c('span', {
    staticClass: "card__contract-value"
  }, [_vm._v(_vm._s(_vm.item.amount_plan) + " ")]), _c('span', {
    staticClass: "card__contract-text"
  }, [_vm._v("руб.")])], 1), _c('div', {
    staticClass: "card__cost"
  }, [_c('Miniheader', {
    attrs: {
      "inline": "inline"
    }
  }, [_vm._v("Объем услуг: ")]), _c('span', {
    staticClass: "card__contract-value"
  }, [_vm._v(_vm._s(_vm.item.duration_plan) + " ")]), _c('span', {
    staticClass: "card__contract-text"
  }, [_vm._v("ч.")])], 1)]), _c('div', {
    staticClass: "card__moreinfo"
  }, [_c('div', {
    staticClass: "card__education"
  }, [_c('Miniheader', [_vm._v("Данные обучения:")]), _c('Infoblock', {
    attrs: {
      "name": "Обучающийся"
    }
  }, [_vm._v(_vm._s(_vm.fio))]), _c('Infoblock', {
    attrs: {
      "name": "Начало"
    }
  }, [_vm._v(_vm._s(_vm.item.start_date_plan))]), _c('Infoblock', {
    attrs: {
      "name": "Окончание"
    }
  }, [_vm._v(_vm._s(_vm.item.end_date_plan) + " (возможно продление договора)")])], 1), _c('div', {
    staticClass: "card__event"
  }, [_c('Miniheader', [_vm._v("Данные программы:")]), _c('Infoblock', {
    attrs: {
      "link": _vm.eventLink,
      "name": "Программа"
    }
  }, [_vm._v(_vm._s(_vm.item.event_name))]), _c('Infoblock', {
    attrs: {
      "name": "Адрес"
    }
  }, [_vm._v(_vm._s(_vm.item.event_location))])], 1), _c('div', {
    staticClass: "card__info"
  }, [_c('Miniheader', [_vm._v("Доп. информация:")]), _c('Infoblock', {
    attrs: {
      "link": _vm.partnerLink,
      "name": "Организация"
    }
  }, [_vm._v(_vm._s(_vm.item.partner_name))]), _c('Infoblock', {
    attrs: {
      "link": _vm.groupLink,
      "name": "Группа"
    }
  }, [_vm._v(_vm._s(_vm.item.group_name))])], 1)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a8e9132","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/cards/contract/Contract.vue
// module id = 9cee5e4bf9ec35f79aea
// module chunks = 89